import * as Sentry from '@sentry/browser';
import hydrate from './hydrate';

Sentry.init({ dsn: 'https://3b0d483a016a4fefb7acaad1cea72087@o173594.ingest.sentry.io/5238591' });

hydrate();
